export const REQUESTOR = 'ubik-lat-post-design-configuration'

export const QUERY_STRING_PARAMS = {
  workId: 'workId',
  careAgent: 'careAgent',
  editSource: 'editSource',
  debugPage: 'debugPage',
}

export const PURCS_ORIGIN_URL = 'https://lookup.previews.cimpress.io'
